import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useContext, useMemo } from 'react';
import { ClearRounded, DashboardCustomizeRounded, DriveFileRenameOutlineRounded, } from '@mui/icons-material';
import { preventDefault, useCallbacks, } from 'shared/hooks/utils';
import { set_ui_settings } from 'console/redux/settings-actions';
import { UniversalMenu } from 'console/shared/components/menu';
import { DeviceUISettingsControl } from 'console/shared/contexts/device-ui-settings/control/types';
import { useAction } from 'shared/hooks/redux/hooks';
export const CustomPanelMenu = memo(function CustomPanelMenu(props) {
    const { onClose, anchor, panel_key, onOpenRenameDialog } = props;
    const { onDeleteCustomPanel, setGroupingPanelKey } = useContext(DeviceUISettingsControl);
    const setUiSettings = useAction(set_ui_settings);
    const onDeleteCustomPanelClick = useCallbacks([
        onClose,
        () => onDeleteCustomPanel(panel_key),
    ]);
    const onChangeCustomPanelClick = useCallback((event) => {
        setUiSettings({ grouping_mode: true });
        setGroupingPanelKey(panel_key);
        preventDefault(event);
        onClose();
    }, [panel_key]);
    const menu_items = useMemo(() => [
        {
            icon: _jsx(DriveFileRenameOutlineRounded, { color: "action" }),
            label: 'Переименовать раздел',
            onClick: onOpenRenameDialog,
        },
        {
            icon: _jsx(DashboardCustomizeRounded, { color: "action" }),
            label: 'Изменить раздел',
            onClick: onChangeCustomPanelClick,
        },
        {
            icon: _jsx(ClearRounded, { color: "action" }),
            label: 'Удалить раздел',
            onClick: onDeleteCustomPanelClick,
        },
    ], []);
    return (_jsx(UniversalMenu, { anchor: anchor, menu_items: menu_items, opened: !!anchor, onClose: onClose }));
});
